import MenuItem from "./MenuItem";
import LinkItem from "./LinkItem";
import Categoria from "./Categoria";
import Menu from "./Menu";

import "./menu-desplegable.scss";

const MenuDesplegable = ({ items = [], carta, menu }) => {
  // console.log("MenuDesplegable", items, carta, menu);
  return (
    <div className="menu-desplegable">
      {carta?.map((itm) => (
        <Categoria title={itm.nombreCategoria} options={itm.categoria} />
      ))}
      {menu?.map((itm) => (
        <Menu title={itm.nombre} {...itm} />
      ))}
      {items?.map((itm, index) =>
        itm.options ? (
          <MenuItem
            key={`menu-item-${index}`}
            title={itm.title}
            description={itm.description}
            options={itm.options}
          />
        ) : (
          <LinkItem
            key={`link-item-${index}`}
            title={itm.title}
            description={itm.description}
            link={itm?.archivo?.mediaItemUrl}
          />
        )
      )}
    </div>
  );
};

export default MenuDesplegable;
